import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftCardGroupTimelineQuery = createQueryHook(
  GiftCardsApiClient.getGiftCardGroupTimeline,
  {
    queryKey: ['giftCardGroupTimeline'],
  },
)
